<span class="vehicle-control-indicator-value">
    <!-- placeholder -->
    <span *ngIf="isLoading === true" class="field-placeholder">-</span>
    <!-- placeholder jak brak wartosci -->
    <span *ngIf="!value && !param" class="field-placeholder">-</span>
    <!-- loaded -->
    <ng-container *ngIf="isLoading !== true">
        <!-- { Type: 13, Name: 'Status' } -->
        <ng-container *ngIf="group === 13 && value">
            <img [src]="value" alt="status" class="status-indicator" />
        </ng-container>
        <!-- { Type: 2, Name: 'Czas' } -->
        <ng-container *ngIf="group === 2 && value">
            {{value | statusTimeFormat}}
        </ng-container>
        <!-- { Type: 3, Name: 'Czujniki' } -->
        <ng-container *ngIf="group === 3 && params">
            <span class="indicator-params-container" [title]="indicatorsTitle">
                <span class="indicator-param" *ngFor="let p of indicatorsList; let first = first;"
                    [ngClass]="{'indicator-param-on' : p.Status === true}">
                    <!--
                    <span *ngIf="!first">,</span>
                    -->
                    {{(p.Name | slice:0:2).toString() | uppercase }}
                </span>
            </span>
        </ng-container>
        <!-- { Type: 4, Name: 'Kierowca' } -->
        <ng-container *ngIf="group === 4 && value">
            <span *ngIf="value" [title]="value | fullName">{{value | fullName}}</span>
        </ng-container>
        <!-- { Type: 3, Name: 'Czujniki' },-->
        <!-- { Type: 5, Name: 'Licznik km' } -->
        <ng-container *ngIf="group === 5 && value">
            {{value.V | number:'1.0-0'}}
            <tk-vehicle-control-indicator-value-type [type]="value.Type"></tk-vehicle-control-indicator-value-type>
        </ng-container>
        <!-- { Type: 6, Name: 'Napięcie' } -->
        <ng-container *ngIf="group === 6 && value">
            {{value.V | number:'1.0-0'}}
            <tk-vehicle-control-indicator-value-type [type]="value.Type"></tk-vehicle-control-indicator-value-type>
        </ng-container>
        <!-- { Type: 7, Name: 'Obroty' } -->
        <ng-container *ngIf="group === 7 && value">
            {{value.V | number:'1.0-0'}}
            <tk-vehicle-control-indicator-value-type [type]="value.Type"></tk-vehicle-control-indicator-value-type>
        </ng-container>
        <!-- { Type: 8, Name: 'Paliwo' } -->
        <ng-container *ngIf="group === 8 && value">
            {{value.V | number:'1.0-0'}}
            <tk-vehicle-control-indicator-value-type [type]="value.Type"></tk-vehicle-control-indicator-value-type>
        </ng-container>
        <!-- { Type: 9, Name: 'Paliwo CAN' } -->
        <ng-container *ngIf="group === 9 && value">
            {{value.V | number:'1.0-0'}}
            <tk-vehicle-control-indicator-value-type [type]="value.Type"></tk-vehicle-control-indicator-value-type>
        </ng-container>
        <!-- { Type: 10, Name: 'Pedał gazu' } -->
        <ng-container *ngIf="group === 10 && value">
            {{value.V | number:'1.0-0'}}
            <tk-vehicle-control-indicator-value-type [type]="value.Type"></tk-vehicle-control-indicator-value-type>
        </ng-container>
        <!-- { Type: 12, Name: 'Prędkość' } -->
        <ng-container *ngIf="group === 12 && value">
            {{value.V | number:'1.0-0'}}
            <tk-vehicle-control-indicator-value-type [type]="value.Type"></tk-vehicle-control-indicator-value-type>
        </ng-container>
        <!-- { Type: 14, Name: 'GPS' } -->
        <ng-container *ngIf="group === 14 && value">
            <tk-vehicle-control-indicator-singnal-value type="GPS" [value]="value.V">
            </tk-vehicle-control-indicator-singnal-value>
        </ng-container>
        <!-- { Type: 15, Name: 'GSM' } -->
        <ng-container *ngIf="group === 15 && value">
            <tk-vehicle-control-indicator-singnal-value type="GSM" [value]="value.V">
            </tk-vehicle-control-indicator-singnal-value>
        </ng-container>
        <!-- { Type: 16, Name: 'Tachograf' } -->
        <ng-container *ngIf="group === 16 && value">
            <!-- aktualne -->
            <span class="tacho-value" [ngClass]="{'actual' : value.s}">
                <span class="tacho-icon tacho-icon-{{value.t}}" [title]="value.title"></span>
                <span class="tacho-value">
                    <tk-time [minutes]="value.v"></tk-time>
                </span>
            </span>
            <!-- jazda -->
            <!-- praca -->
            <!-- odpoczynek -->
            <!-- dostepnosci-->
        </ng-container>
        <!-- { Type: 17, Name: 'Temperatura' } -->
        <ng-container *ngIf="group === 17 && value">
            <span [title]="label">{{value.V}}</span>
        </ng-container>
        <!-- { Type: 18, Name: 'Zuzycie CAN' } -->
        <ng-container *ngIf="group === 18 && value">
            {{value.V | number:'1.0-0'}}
            <tk-vehicle-control-indicator-value-type [type]="value.Type"></tk-vehicle-control-indicator-value-type>
        </ng-container>
        <ng-container *ngIf="group === 19 && value">
            <img [src]="value" title="{{vehicle!.getEtollStatusHint()}}" class="eTollColumn" />
        </ng-container>
        <!-- inne przypadku -->
        <ng-container *ngIf="param && param.LV">
            <!-- czujniki binarne -->
            <ng-container *ngIf="[9].indexOf(param.Tp) !== -1">
                <!--odwrotnie -->
                <span *ngIf="param.LV.V !== true" class="value-boolean off">OFF</span>
                <span *ngIf="param.LV.V === true" class="value-boolean on">ON</span>
            </ng-container>
            <ng-container *ngIf="[16].indexOf(param.Tp) !== -1">
                <span *ngIf="param.LV.V === true" class="value-boolean off">OFF</span>
                <span *ngIf="param.LV.V !== true" class="value-boolean on">ON</span>
            </ng-container>
            <ng-container *ngIf="[19].indexOf(param.Tp) !== -1">
                <span *ngIf="param.LV.V === true" class="value-boolean off">OFF</span>
                <span *ngIf="param.LV.V !== true" class="value-boolean on">ON</span>
            </ng-container>
            <ng-container *ngIf="[26].indexOf(param.Tp) !== -1">
                <span *ngIf="param.LV.V === true" class="value-boolean off">OFF</span>
                <span *ngIf="param.LV.V !== true" class="value-boolean onn">ON</span>
            </ng-container>


            <!-- czujniki inne -->
            <ng-container *ngIf="[9, 16, 19, 26].indexOf(param.Tp) === -1">
                <span *ngIf="param.LV.V">
                    {{ param.LV.V | number:'1.0-0' }} <tk-vehicle-control-indicator-value-type [type]="param.Tp">
                    </tk-vehicle-control-indicator-value-type>
                </span>
                <span *ngIf="!param.LV.V">
                    0 <tk-vehicle-control-indicator-value-type [type]="param.Tp">
                    </tk-vehicle-control-indicator-value-type>
                </span>
            </ng-container>
        </ng-container>
    </ng-container>
</span>
